import { CanActivateFn, ActivatedRouteSnapshot } from '@angular/router';
import { StorageConstants } from 'src/app/shared/constants/storage-constants';

export const QueryParamsGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const companyCode = route.queryParams['company'];

  if (companyCode?.trim()) {
    const normalizedCode = companyCode.trim().toUpperCase();
    if (/^[A-Z]{3,4}$/.test(normalizedCode)) {
      sessionStorage.setItem(StorageConstants.CompanyCode, normalizedCode);
    }
  }

  return true;
};
